import { cn } from '@/utils';
import { CloseOutlined } from '@ant-design/icons';
import React, { memo, useCallback } from 'react';
import { ResizableBox } from 'react-resizable';

import { Popover } from 'antd';

import './styles.scss';

import { TableWithActions } from '..';
import Button from '../common/button';
import useLogic from './work-history-layer.logic';
import { TWorkHistoryLayerProps } from './work-history-layer.type';

const WorkHistoryLayerView: React.FC<TWorkHistoryLayerProps> = (
	props: TWorkHistoryLayerProps
) => {
	const {
		columns,
		state,
		handleClosePopover,
		handleOpenPopover,
		onClick,
		handleResize,
		scrollHeight,
		workHistoryList,
		loading,
	} = useLogic(props);

	const table = useCallback(() => {
		return (
			<div onClick={onClick} className="overflow-y-auto">
				<div className="flex justify-between items-center">
					<p className="text-base font-semibold text-black">근무 이력</p>
					<div>
						<Button
							icon={<CloseOutlined className="w-4 h-4" />}
							type="text"
							className="min-w-10"
							onClick={handleClosePopover}
						/>
					</div>
				</div>
				<TableWithActions
					actionHidden
					columns={columns}
					dataSource={workHistoryList}
					rowKey={'id'}
					pagination={false}
					loading={loading}
					className="work-history-table"
					containerClassName="p-0"
					scroll={{ y: scrollHeight }}
				/>
			</div>
		);
	}, [columns, scrollHeight, workHistoryList, loading]);

	const contentPopover = useCallback(() => {
		return (
			<div onClick={onClick}>
				<ResizableBox
					width={state.width}
					height={state.height}
					resizeHandles={['sw']}
					minConstraints={[600, 260]}
					maxConstraints={[1500, 800]}
					className="resize-box"
					onResize={handleResize}
				>
					{table()}
				</ResizableBox>
			</div>
		);
	}, [state, table]);

	return (
		<div className="render-cell">
			<Popover
				placement="bottomRight"
				content={contentPopover}
				prefixCls="work-history"
				trigger={'click'}
				arrow={{
					pointAtCenter: true,
				}}
				open={state.visible}
				onOpenChange={handleOpenPopover}
			>
				<div
					onClick={onClick}
					className={cn(
						'text-blue2 text-[13px] underline hover:font-bold my-auto h-full cursor-pointer',
						state.visible ? 'font-bold' : ''
					)}
				>
					더보기
				</div>
			</Popover>
		</div>
	);
};

export default memo(WorkHistoryLayerView);
